import { render, staticRenderFns } from "./metal_prc.vue?vue&type=template&id=e8e9d536&scoped=true&"
import script from "./metal_prc.vue?vue&type=script&lang=js&"
export * from "./metal_prc.vue?vue&type=script&lang=js&"
import style0 from "./metal_prc.vue?vue&type=style&index=0&id=e8e9d536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e9d536",
  null
  
)

export default component.exports